import clsx, { type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Standard clsx + tailwind-merge helper used by every UI-kit component. */
export function cn(...inputs: ClassValue[]): string {
	return twMerge(clsx(inputs))
}
